import Swiper from "swiper";
import { Autoplay } from 'swiper/modules';

export const SwiperHeroHome = () => {
	// console.log("SwiperHeroHome");
	const slide = new Swiper(".swiper-home", {
		modules: [Autoplay],
		loop: true,
		slidesPerView: 'auto',
		freeMode: true,
		speed: 8000, // quanto maior, mais suave
		grabCursor: false,
		// centeredSlides: true,
		// centeredSlidesBounds: false,
		// slidesPerView: 3,
		spaceBetween: 24,
		allowTouchMove: false,
		simulateTouch: false,
		grabCursor: false,
		mousewheel: false,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		breakpoints: {
			0: {
				spaceBetween: 8,
				slidesPerView: 1,
			},
			768: {
				spaceBetween: 24,
				slidesPerView: 1,
			},
			1024: {
				spaceBetween: 24,
				slidesPerView: 3,
			},
		},
	});
};
